// extracted by mini-css-extract-plugin
export default {"root":"Y9wfgZa62KT8CP6eSrr9","dropdown":"Qd5wN5pakH_qXdxoZgZY","placeholder":"jUT2U7fK4Bx1pSfhsaAP","icon":"SNTRYMNhmOPThoJqWxYv","placeHolderShimmer":"h3Xpo1Go9c5nVAdOka_C"};